import * as React from 'react'
import { bindActionCreators } from 'redux'
import {connect, useDispatch} from 'react-redux'
import {useMemo} from 'react'
import { Creators } from '../../../redux/modals'

export default function withNavigator(WrappedComponent) {
  class NewComponent extends React.Component {
    constructor(props) {
      super(props)
      this.boundActionCreators = bindActionCreators(Creators, props.dispatch)
    }

    render() {
      return <WrappedComponent modals={this.boundActionCreators} {...this.props} />
    }
  }

  const selector = state => ({
    currentUser: state.user,
  })

  return connect(selector)(NewComponent)
}

/**
 * @returns {DefaultActionCreators | { open: any, openSingleton:any, close: any }}
 */
export const useNavigator = () => {
  const dispatch = useDispatch()
  const actions = useMemo(()=>bindActionCreators(Creators, dispatch), [dispatch])
  return actions
}
